/* RESPONSIBLE TEAM: team-standalone */

import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type Model from '@ember-data/model';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { taskFor } from 'ember-concurrency-ts';

export default class SalesforceInAppMessagingApiIntegrationIsValid extends BaseValidator {
  @service declare intl: IntlService;

  async validate(
    _value: unknown,
    _options: ValidationOptions,
    model: Model & {
      app: any;
      finStandaloneService: FinStandaloneService;
    },
  ) {
    if (model.app.isStandaloneApp || model.app.hasStandalonePlatform('salesforce')) {
      await this.waitForSalesforceInAppMessagingConfig(model.finStandaloneService);
      if (model.finStandaloneService.salesforceInAppMessagingConfig?.isConnected) {
        return true;
      }
    }

    return this.intl.t(
      'operator.workflows.visual-builder.handoff-to-salesforce-in-app-messaging.invalid-api-connection',
    );
  }

  static getDependentsFor() {
    return [
      'model.app',
      'model.app.isStandaloneApp',
      'model.app.standalone_platforms',
      'model.finStandaloneService.salesforceInAppMessagingConfig',
    ];
  }

  async waitForSalesforceInAppMessagingConfig(finStandaloneService: FinStandaloneService) {
    // This works under the assumption that the salesforce in-app messaging config data is loaded or loading.
    // As part of initializing the finStandaloneService.
    if (!taskFor(finStandaloneService.loadSalesforceInAppMessagingConfig).isRunning) {
      return;
    }

    return taskFor(finStandaloneService.loadSalesforceInAppMessagingConfig).last!;
  }
}
